import React from 'react';
import { Upload } from 'lucide-react';

interface FileUploadProps {
  id: string;
  type: 'productImage' | 'animatedGif';
  accept: string;
  url: string;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>, type: 'productImage' | 'animatedGif') => void;
  onRemove: () => void;
  label: string;
}

export default function FileUpload({
  id,
  type,
  accept,
  url,
  onFileChange,
  onRemove,
  label
}: FileUploadProps) {
  return (
    <div className="border-2 border-dashed rounded-md p-4 text-center">
      {url ? (
        <div className="space-y-2">
          <img 
            src={url} 
            alt={`${type} preview`} 
            className="max-w-full h-auto mx-auto"
          />
          <button
            type="button"
            onClick={onRemove}
            className="text-red-500 text-sm hover:text-red-600"
          >
            Remove
          </button>
        </div>
      ) : (
        <>
          <Upload className="mx-auto h-12 w-12 text-gray-400" />
          <input
            type="file"
            onChange={(e) => onFileChange(e, type)}
            className="hidden"
            id={id}
            accept={accept}
          />
          <label
            htmlFor={id}
            className="mt-2 cursor-pointer text-sm text-blue-500 hover:text-blue-600"
          >
            {label}
          </label>
        </>
      )}
    </div>
  );
}